import React, { useState } from 'react';
import axios from 'axios';
import baseURL from '../../Config';
export default function DevelopmentSafety({ admin }) {
    const [rows, setRows] = useState(null), [error, setError] = useState('');
    if (process.env.NODE_ENV !== 'development') return null;
    async function load() {
        try {
            const user = JSON.parse(localStorage.getItem('userDetails') || localStorage.getItem('adminUser') || '{}');
            const result = await axios.get(`${baseURL}dev/outbox`, { headers: { Authorization: `Bearer ${user?.data?.token || user?.data?.accessToken}` } });
            setRows(result.data.data); setError('');
        } catch (_) { setError('No se pudo cargar la bandeja de desarrollo.'); }
    }
    return <aside style={{ background: '#fef3c7', padding: 8, position: 'fixed', bottom: 0, zIndex: 9999, maxHeight: '60vh', overflow: 'auto' }}>
        <strong>DESARROLLO</strong> {admin && <button onClick={load}>Mensajes suprimidos</button>}
        {error && <p role="alert">{error}</p>}
        {rows && <><button onClick={() => setRows(null)}>Cerrar</button><p>Solo evidencia de prueba; estos mensajes no fueron enviados.</p>{rows.map(row => <details key={row._id}><summary>{row.channel} · {row.to.join(', ')} · {row.createdAt}</summary><pre>{JSON.stringify(row.payload, null, 2)}</pre></details>)}</>}
    </aside>;
}
